/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface UtmSave200ResponseData
 */
export interface UtmSave200ResponseData {
  /**
   * Идентификатор клиента UTM-трекинга (передаётся в дальнейшие события)
   * @type {string}
   * @memberof UtmSave200ResponseData
   */
  clientId: string
}

/**
 * Check if a given object implements the UtmSave200ResponseData interface.
 */
export function instanceOfUtmSave200ResponseData(
  value: object
): value is UtmSave200ResponseData {
  if (!('clientId' in value) || value['clientId'] === undefined) return false
  return true
}

export function UtmSave200ResponseDataFromJSON(
  json: any
): UtmSave200ResponseData {
  return UtmSave200ResponseDataFromJSONTyped(json, false)
}

export function UtmSave200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UtmSave200ResponseData {
  if (json == null) {
    return json
  }
  return {
    clientId: json['clientId'],
  }
}

export function UtmSave200ResponseDataToJSON(
  value?: UtmSave200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    clientId: value['clientId'],
  }
}
